import { render } from "./PlaybookActivitySidebar.vue?vue&type=template&id=a64a0fd0&scoped=true"
import script from "./PlaybookActivitySidebar.vue?vue&type=script&lang=js"
export * from "./PlaybookActivitySidebar.vue?vue&type=script&lang=js"

import "./PlaybookActivitySidebar.vue?vue&type=style&index=0&id=a64a0fd0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64a0fd0"]])

export default __exports__